import React, { Fragment, useState } from 'react';
// import PropTypes from 'prop-types';
import LoadingScreen from '../components/Complements/LoadingScreen';
import Dashboard from '../components/Menu/Dashboard';
import StandardDialog from '../components/Complements/StandardDialog';
import DialogOTP from '../components/Complements/DialogOTP';
import { buttonsApp, stepperStyles } from '../styles/GeneralStyles';
import { Grid, Stepper, Step, StepLabel, StepContent, Typography, Card, CardContent, Button } from '@material-ui/core';
import ChargeInfoCustomerReduxForm from '../components/TestingCredits/ChargeInfoCustomer';
import RequestCreditTestReduxForm from '../components/TestingCredits/RequestCreditTest';
import { history } from '../helpers/history';
import AmortizationTable from '../components/TestingCredits/AmortizationTable';
import UploadFiles from '../components/TestingCredits/UploadFiles';
//import { osName, osVersion } from 'react-device-detect';
//import { isEmpty } from '../functions/arrays';
//import { validateIp } from '../functions/store';
import { createProcessMeterCode } from '../actions/metersCore';
import { getCreditDestiny, getCreditApplicationQualifier, getCreditInformation } from '../actions/digitalCredit';
import { feathersCreateData } from '../services';
import { connect } from "react-redux";
import Congratulations from '../components/TestingCredits/Congratulations';
import { encrypt/* , sendMobile , decrypt*/ } from '../functions/mobile';
import { filterArrayEqual } from '../functions/arrays';

const CreditRequestTestContainer = props => {
    const { user, /* precalificacion, */ handleOpenSnack, documentos, parameters, devices/* , auth */ } = props
    //console.log('documentos', documentos)
    const classes = buttonsApp()
    const classesSteppers = stepperStyles()
    const [loading, setLoading] = useState(false)
    // const [ amountSelected, setAmountSelected ] = useState('0.00')
    const [creditOptions, setCreditOptions] = useState({})
    const [dialog, setDialog] = useState({ state: false, title: '', content: <div></div> })
    const [paymentRequestData, setPaymentRequestData] = useState({
        amount: 0, timeLimit: 0, paymentDay: 0
    })
    const [score, setScore] = useState({})
    const [activeStep, setActiveStep] = useState(0)
    const steps = ['Información Socio', 'Evaluación del modelo', 'Tabla amortización', 'Completar Información', 'Desembolso'];
    /* const [OTP, setOTP] = useState({
        id: '',
        openOtp: false,
        type: '',
        code: ''
    }) */
    const [openDialogOtp, setOpenDialogOtp] = useState(false)
    const [filesRequest, setFilesRequest] = useState(0)

    const [stepOneData, setStepOneData] = useState({
        amount: 1500, expenses: 500, diference: 0
    })
    const [stepTwoData, setTwoData] = useState({
        creditProposit: 'AL', amountRequest: 300, higherAmount: 0, term: 6, paymentFrequency: 'MENSUAL', paymentDay: 1, typeFee: 'Fija'
    })

    const [stepThreeData, setThreeData] = useState({})

    const handleChangeInputOtp = (valueinput) => {
        const tokenLengthObj = filterArrayEqual(parameters, 'code', 'NUMBER_OF_CHARACTERS_TOKEN')
        // console.log(tokenLengthObj)
        const tokenLength = (tokenLengthObj.length > 0) ? parseInt(tokenLengthObj[0].value) : 8
        if (valueinput.target.value.toString().length === tokenLength) {
            handleOTPCompare({ data: valueinput.target.value.toString() });
        }
    }

    const cleanDialog = () => {
        setLoading(false)
        setDialog({
            state: false,
            title: '',
            content: <div></div>
        })
    }

    const handleOTPCompare = async (otp) => {
        // const { id } = auth
        // console.log('data', otp)
        setLoading(true)
        /* await feathersCreateData("code-validation", {
            otp: data,
            type: 17,
            user: auth.identification
        })().then(async res => {
            // setLoading(false)
            if (res.type === 'success') {
                setLoading(false)
                setActiveStep(4)
                setOTP({ ...OTP, openOtp: false })
            } else {
                setLoading(false)
                handleOpenSnack(res.message, res.type)
            }
        }).catch(err => {
            setLoading(false)
            handleOpenSnack('El código OTP no es correcto. Por favor intente nuevamente.', 'error')
        }) */

        const { ip, device, mac } = devices

        const sendData = encrypt(JSON.stringify({
            ip,
            mac,
            device,
            type: 17,
            inputOtp: otp.data
        }))

        const responseValidateCode = await feathersCreateData("code-validation", { sendData })()
        // console.log('responseValidateCode', responseValidateCode)
        //const responseValidateCodeDecrypt = JSON.parse(decrypt(responseValidateCode.responseData))


        /* console.log('responseValidateCodeDecrypt', responseValidateCodeDecrypt) */


        const { error, message, type: typeMessage, viewDialogOtp } = responseValidateCode;
        if (error === false) {

            /* const responseUsernameChange = await feathersCreateData("procces-username-change", {
                ip,
                mac,
                device,
                otp: data,
                username
            })()

            // console.log(responseUsernameChange)

            if (responseUsernameChange.status === true) {
                props.changeStatusFlagUsernameChange(0)
                history.push('/')
                handleOpenSnack(responseUsernameChange.message, "success")

            } else {
                
                handleOpenSnack(responseUsernameChange.message, "error")
            } */

            setOpenDialogOtp(false)
            setLoading(false)
            getDisbursement()
            //setActiveStep(4)

        } else {

            if (viewDialogOtp === false) {
                setOpenDialogOtp(false)
            }
            setLoading(false)
            handleOpenSnack(message, typeMessage);
        }

    }

    const getDestiny = async () => {
        await props.getCreditDestiny({}).then(response => {
            //console.log(response.payload.data)
            setCreditOptions(response.payload.data)
            //return true
        }).catch(
            error => {
                // console.log(error)
                return false
            }
        )
        //console.log(resul)
    }

    const stepOneSubmit = async (values) => {
        await getDestiny()
        // console.log(values)
        const { amount, expenses } = values
        const diference = amount - expenses
        let amount_float = parseFloat(amount).toFixed(2)
        let expenses_float = parseFloat(expenses).toFixed(2)
        setStepOneData({ ...values, amount_float, expenses_float, diference })

        if (parseFloat(amount) < parseFloat(expenses)) {
            handleOpenSnack("Los Ingresos deben ser mayor a los gastos")
        } else {
            setActiveStep(1)
        }
    }
    /* const dialogFactor = (amountResult) => {
        setDialog({
            state: true,
            title: 'Credito Pre aprobado',
            content: <Card variant="outlined" style={{ height: '100%' }}>
                <CardContent style={{ height: '100%' }}>
                    <Grid container spacing={3} justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={12} lg={12} xl={12}>
                            <b>{`Tiene un credito pre aprobado de $${amountResult}`} </b><br />
                        </Grid>
                        <Grid item xs={12} md={6} lg={6} xl={6}>
                            <Button variant="contained" color="primary" onClick={() => {
                                setActiveStep(2)
                                cleanDialog()
                            }} fullWidth className={classes.buttonBack}>
                                Continuar
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6} xl={6}>
                            <Button variant="contained" color="primary" onClick={() => {
                                history.push('/')
                                cleanDialog()
                            }} fullWidth className={classes.buttonBack}>
                                Cancelar
                            </Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

        })
    } */
    /* const dialogReject = () => {
        setDialog({
            state: true,
            title: 'Solicitud Crédito',
            content: <Card variant="outlined" style={{ height: '100%' }}>
                <CardContent style={{ height: '100%' }}>
                    <b>{`Su solicitud sera procesada, pronto nos pondremos en contacto con usted`} </b><br />
                    <Button variant="contained" color="primary" onClick={() => history.push('/')} fullWidth className={classes.buttonStandard}>
                        Cancelar
                    </Button>
                </CardContent>
            </Card>

        })
    } */

    const getQualifier = async (actionType, requestSequential, values) => {
        setLoading(true)
        // console.log('values', values)
        // console.log('paymentRequestData.amount', values.amountRequest)
        // console.log('stepOneData', stepOneData)
        // const amount_borrar = parseFloat(stepOneData.amount_float).toFixed(2)
        // console.log(typeof amount_borrar, amount_borrar)
        // console.log(typeof stepOneData.amount)
        // console.log(typeof stepOneData.expenses)
        // console.log(typeof stepOneData.amount_float)
        // console.log(typeof stepOneData.expenses_float)
        await props.getCreditApplicationQualifier({
            codigoUsuario: "dycotein",
            tipoAccion: actionType,
            secuencialCliente: stepOneData.user.secuencialCliente,
            ingresos: parseFloat(stepOneData.amount).toFixed(2),
            gastos: parseFloat(stepOneData.expenses).toFixed(2),
            codigoDestinoCredito: values.creditProposit,
            montoSolicitado: values.amountRequest,
            numeroCuotas: parseInt(values.term),
            frecuenciaPago: 30,
            esCuotaFija: (values.typeFee === 'Fija' ? true : false),
            diaDePago: values.paymentDay,
            secuencialSolicitud: requestSequential
        }).then(async response => {

            // console.log(typeof response.payload.data.isError, response.payload.data.isError)
            //console.log(response.payload.data.resultadoEvaluacionResponse)
            if (response.payload.data.isError === true) {
                // console.log('error')
                setLoading(false)
                handleOpenSnack("Ha ocurrido un error en el servicio de crédito digital, inténtelo más tarde", "error")
            } else {
                let res = response.payload.data.resultadoEvaluacionResponse
                // console.log(res.aprobado)
                // console.log('res', res)
                setScore(response.payload.data.resultadoEvaluacionResponse)
                if (res.codigoDecision === "1") {
                    // console.log('res1', res)
                    // console.log(stepOneData)
                    // console.log(paymentRequestData)
                    await props.getCreditApplicationQualifier({
                        codigoUsuario: "dycotein",
                        tipoAccion: 1,
                        secuencialCliente: stepOneData.user.secuencialCliente,
                        ingresos: parseFloat(stepOneData.amount).toFixed(2),
                        gastos: parseFloat(stepOneData.expenses).toFixed(2),
                        codigoDestinoCredito: values.creditProposit,
                        montoSolicitado: values.amountRequest,
                        numeroCuotas: parseInt(values.term),
                        frecuenciaPago: 30,
                        esCuotaFija: (values.typeFee === 'Fija' ? true : false),
                        diaDePago: values.paymentDay,
                        secuencialSolicitud: requestSequential
                    }).then(response => {

                        /* setScore(response.payload.data)
                        // PRE aprobado
                        setActiveStep(2) */
                        // console.log('response', response)
                        if (response.payload.data.isError === true) {
                            history.push('/')
                            handleOpenSnack(response.payload.data.mensaje, "error")
                        } else {
                            // console.log('response.payload.data.identificadorUnicoSolicitud', response.payload.data.identificadorUnicoSolicitud)
                            //console.log('response.payload.data.identificadorUnicoSolicitud', typeOf(response.payload.data.identificadorUnicoSolicitud))
                            setThreeData(values)
                            getInformation(response.payload.data.identificadorUnicoSolicitud)
                        }
                    })

                } else if (res.codigoDecision === "2") {
                    // console.log('res2', res)
                    // console.log('2')
                    history.push('/')
                    handleOpenSnack("Su solicitud de crédito ha sido guardada y un asesor se contactara con usted en 24 horas", "success")
                    // FACTOR
                    //dialogFactor(amountResult)
                } else if (res.codigoDecision === "3") {
                    // console.log('res3', res)
                    // console.log('3')
                    history.push('/')
                    handleOpenSnack("Su solicitud de crédito ha sido guardada y un asesor se contactara con usted en 48 horas", "success")
                    // RECHAZADO
                    //dialogReject()
                } else {
                    // console.log('res45', res)
                    // console.log('4 5')
                    history.push('/')
                    handleOpenSnack("Su solicitud de crédito ha sido rechazada", "error")
                }
                return res
            }

            //await validar()
            //console.log(score())
        }).catch(
            error => {
                // console.log(error)
                //return false
            }
        )
    }


    const stepTwoSubmit = async (values) => {
        // console.log('stepTwo values', values)
        //const { score, percent } = precalificacion
        //score = 601
        await getQualifier(0, 0, values)
        /* await props.getCreditApplicationQualifier({
            codigoUsuario: "dycotein",
            tipoAccion: 0,
            secuencialCliente: 140400,
            ingresos: stepOneData.amount,
            gastos: stepOneData.expenses,
            codigoDestinoCredito: "OT",
            montoSolicitado: paymentRequestData.amount,
            numeroCuotas: 15,
            frecuenciaPago: 30,
            esCuotaFija: true,
            diaDePago: 5,
            secuencialSolicitud: 0
        }).then(async response => {
            let borrar = response.payload.data.resultadoEvaluacionResponse
            // console.log(borrar)
            setScore(response.payload.data.resultadoEvaluacionResponse)
        }).catch(
            error => {
                // console.log(error)
            }
        ) */
        /* .then(response => {
            // console.log(response)
            // console.log(response.resultadoEvaluacionResponse)
            //setCreditOptions(response.payload.data)
            //return true
        }).catch(
            error => {
                // console.log(error)
                //return false
            }
        ) */
        //const scoreFunc = await getQualifier(0,0)
        // console.log('score', score)

        //console.log(scoreFunc)
        //console.log(values)
        //let amountResult = parseFloat(percent) * (parseFloat(values.amountRequest))
        setPaymentRequestData({ ...values, amountRequest: values.amountRequest })
        setTwoData({ ...stepTwoData, amountRequest: values.amountRequest })

        // console.log('stepTwoData', stepTwoData)
        /* if (parseInt(700) > 600) {
            // console.log('1')
            // PRE aprobado
            setActiveStep(2)
        } else if (parseInt(score) >= 600 || parseInt(score) <= 750) {
            // console.log('2')
            // FACTOR
            dialogFactor(amountResult)
        } else if (parseInt(score) < 600) {
            // console.log('3')
            // RECHAZADO
            dialogReject()
        } */

    }

    const getInformation = (idRequest) => {
        // console.log('idRequest', idRequest)
        props.getCreditInformation({
            identificadorUnicoSolicitud: idRequest
        }).then(response => {
            setLoading(false)
            // console.log('response', response)
            // console.log(response.payload.data)
            // setCreditOptions(response.payload.data)
            setScore(response.payload.data)
            // PRE aprobado
            setActiveStep(2)
            //disbursementDialog()
            //return response.payload.data
        }).catch(
            error => {
                // console.log(error)
                return false
            }
        )
    }

    const validar = async (value) => {
        if (value.aprobado === true) {
            // console.log('value', value)
        }
    }

    const stepThreeSubmit = async () => {
        let isCorrect = true
        let fr = []
        for (const key in documentos) {
            const element = documentos[key];
            // console.log(element)
            switch (key) {
                case 'cedule':
                    if (element === 0) {
                        isCorrect = false
                        fr.push({ name: 'cedule', label: 'Subir archivo Cedula' })
                    }
                    break;
                case 'voting_certificate':
                    if (element === 0) {
                        isCorrect = false
                        fr.push({ name: 'voting_certificate', label: 'Subir Certificado de votacion' })
                    }
                    break;
                case 'spreadsheet':
                    if (element === 0) {
                        isCorrect = false
                        fr.push({ name: 'income_certificate', label: 'Subir Certificado de ingresos' })
                    }
                    break;
                case 'income_certificate':
                    if (element === 0) {
                        isCorrect = false
                    }
                    break;
                default:
                    break;
            }

        }
        fr.push({ name: 'cedule', label: 'Subir archivo Cédula' })
        fr.push({ name: 'voting_certificate', label: 'Subir Certificado de votación' })
        fr.push({ name: 'income_certificate', label: 'Subir Certificado de ingresos' })
        setFilesRequest(fr)
        if (isCorrect) {
            //setLoading(true)
            //handleOtpRequest()
            //disbursementDialog()
            setActiveStep(3)
        } else {
            setActiveStep(3)
        }
    }

    const getDisbursement = async () => {
        setLoading(true)
        // console.log('score.secuencialSolicitud', score.secuencialSolicitud)
        // console.log('paymentRequestData.amount', paymentRequestData.amount)
        await props.getCreditApplicationQualifier({
            codigoUsuario: "dycotein",
            tipoAccion: 2,
            secuencialCliente: stepOneData.user.secuencialCliente,
            ingresos: parseFloat(stepOneData.amount).toFixed(2),
            gastos: parseFloat(stepOneData.expenses).toFixed(2),
            codigoDestinoCredito: stepThreeData.creditProposit,
            montoSolicitado: paymentRequestData.amount,
            numeroCuotas: parseInt(stepThreeData.term),
            frecuenciaPago: 30,
            esCuotaFija: true,
            diaDePago: stepThreeData.paymentDay,
            secuencialSolicitud: score.secuencialSolicitud
        }).then(async response => {
            //console.log(response.payload.data)
            //console.log(response.payload.data.resultadoEvaluacionResponse)
            let res = response.payload.data
            // console.log('response', response)
            //setScore(response.payload.data.resultadoEvaluacionResponse)
            if (res.isError === false) {
                // console.log(stepOneData)
                // console.log(paymentRequestData)
                await props.getCreditApplicationQualifier({
                    codigoUsuario: "dycotein",
                    tipoAccion: 3,
                    secuencialCliente: stepOneData.user.secuencialCliente,
                    ingresos: parseFloat(stepOneData.amount).toFixed(2),
                    gastos: parseFloat(stepOneData.expenses).toFixed(2),
                    codigoDestinoCredito: stepThreeData.creditProposit,
                    montoSolicitado: stepThreeData.amountRequest,
                    numeroCuotas: parseInt(stepThreeData.term),
                    frecuenciaPago: 30,
                    esCuotaFija: true,
                    diaDePago: stepThreeData.paymentDay,
                    secuencialSolicitud: score.secuencialSolicitud
                }).then(response => {
                    // console.log('response', response)
                    // console.log('response.payload.data.identificadorUnicoSolicitud', response.payload.data.identificadorUnicoSolicitud)
                    setLoading(false)
                    setActiveStep(4)
                    //console.log('response.payload.data.identificadorUnicoSolicitud', typeOf(response.payload.data.identificadorUnicoSolicitud))
                    //getInformation(response.payload.data.identificadorUnicoSolicitud)
                })

            } else {
                // console.log('4 5')
                history.push('/')
                handleOpenSnack("Error en solicitud de crédito", "error")
            }
            //await validar()
            //console.log(score())
            return res
        }).catch(
            error => {
                // console.log(error)
                //return false
            }
        )
    }

    const disbursementDialog = () => {
        setDialog({
            state: true,
            title: 'Desembolso',
            content: <Card variant="outlined" style={{ height: '100%' }}>
                <CardContent style={{ height: '100%' }}>
                    <Grid container spacing={3} justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={12} lg={12} xl={12}>
                            <b>{`Desea desembolsar $${paymentRequestData.amountRequest} para su crédito`} </b><br />
                        </Grid>
                        <Grid item xs={12} md={6} lg={6} xl={6}>
                            <Button variant="contained" onClick={() => {
                                handleOtpRequest()
                                cleanDialog()
                            }} fullWidth className={classes.buttonStandard}>
                                Continuar
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6} xl={6}>
                            <Button variant="contained" onClick={() => {
                                history.push('/')
                                cleanDialog()
                            }} fullWidth className={classes.buttonStandard}>
                                Cancelar
                            </Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

        })
    }
    const stepFourSubmit = async () => {
        disbursementDialog()
    }

    const handleOtpRequest = async () => {
        //const { ip } = devices
        const { ip, device, mac } = devices
        //const { getDeviceData, updateIpDevice } = props
        /* let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
        let deviceData = `${osName} ${osVersion}` */
        //let mac = 'NAVEGADOR'
        /* if (!isEmpty(devices)) {
            // const { device, ip: ipDevice, mac: macDevice } = devices
            const { ip: ipDevice, mac: macDevice } = devices
            // deviceData = device;
            ipSend = ipDevice;
            mac = macDevice;
        } */
        let sendData = encrypt(JSON.stringify({
            emited: 'NAVCREATECODE',
            type: 17,
            deviceData: device,
            ip,
            mac
        }))

        //await feathersCreateData('codes-recovery', { emited: 'NAVCREATECODE', type: 17, deviceData, ip: ipSend, mac })()
        await feathersCreateData('codes-recovery', { sendData })()
        /* .then(({ payload }) => {
            setOTP({
                ...OTP,
                type: 'PROCESS',
                openOtp: true
            })
            setLoading(false)
        }).catch(err => {
            setLoading(false)
            handleOpenSnack('No se ha podido realizar la transacción. Por favor intente nuevamente', 'error')
        }) */

        setOpenDialogOtp(true)

        setLoading(false)

        /* this.setState({
            initialTime: Date.now(),
            openDialogOTP: true,
            loading: false
        }) */
    }

    /* refreshToken = async () => {

        try {

            this.setState({
                loading: true
            })
            const { devices } = this.props
            const { ip, mac, device } = devices
            const sendData = encrypt(JSON.stringify({ emited: 'NAVCREATECODE', type: 17, deviceData: device, ip, mac }))
            const responseGenerateCode = await feathersCreateData("codes-recovery", { sendData })()
            const { responseData } = responseGenerateCode
            const jsonDecrypt = JSON.parse(decrypt(responseData))

            const { type, alert } = jsonDecrypt;

            if (type === 'success') {
                this.setState(
                    {
                        openDialogOTP: true,
                        loading: false
                    })
            } else {
                this.setState({
                    loading: false
                })
                this.props.handleOpenSnack(alert, type)
            }

        } catch (error) {
            this.setState({
                loading: false
            })
            this.props.handleOpenSnack("Ha ocurrido un error al generar el código.", "error")
        }
    } */

    const handleProcessGenerateOtp = async () => {

        try {

            setLoading(true)

            const { ip, device, mac } = devices

            const sendData = encrypt(JSON.stringify({
                emited: 'NAVCREATECODE', type: 17, deviceData: device, ip, mac
            }))

            await feathersCreateData('codes-recovery', { sendData })()

            //console.log(responseGenerateOtp)

            setOpenDialogOtp(true)

            setLoading(false)

        } catch (error) {

            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al generar el código", "error")

        }
    }

    const getStepContent = (stepIndex) => {
        switch (stepIndex) {
            case 0:
                return <Grid container spacing={3} >
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <ChargeInfoCustomerReduxForm onSubmit={stepOneSubmit} user={user} {...stepOneData} />
                    </Grid>
                </Grid>
            case 1:
                return <Grid container spacing={3} >
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <RequestCreditTestReduxForm onSubmit={stepTwoSubmit} {...stepTwoData} getBack={() => setActiveStep(activeStep - 1)} creditDestiny={creditOptions} />
                    </Grid>
                </Grid>
            case 2:
                return <Grid container spacing={3} >
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <AmortizationTable amount={parseFloat(paymentRequestData.amountRequest)} timeLimit={parseInt(paymentRequestData.term)}
                            paymentDay={paymentRequestData.paymentDay} diference={stepOneData.diference} handleOpenSnack={handleOpenSnack}
                            getBack={() => setActiveStep(activeStep - 1)} getNext={stepThreeSubmit} score={score} validar={validar} getInformation={getInformation} />
                    </Grid>
                </Grid>
            case 3:
                return <Grid container spacing={3} >
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <UploadFiles onSubmit={stepFourSubmit} getBack={() => setActiveStep(activeStep - 1)} filesRequest={filesRequest} />
                    </Grid>
                </Grid>
            case 4:
                return <Grid container spacing={3} >
                    <Grid item xs={12} md={12} lg={12} xl={12}>
                        <Congratulations />
                    </Grid>
                </Grid>
            default:
                break;
        }
    }
    const renderBody = () => {
        return <Fragment>
            <Stepper activeStep={activeStep} orientation="vertical" className={classesSteppers.stepper}>
                {
                    steps.map((label) => (
                        <Step key={label}>
                            <StepLabel >{label}</StepLabel>
                            <StepContent>
                                <Fragment>
                                    {
                                        activeStep === steps.length ? (
                                            <Fragment>
                                                <Typography className={classesSteppers.instructions}>DPF SOlicitado</Typography>
                                            </Fragment>
                                        ) : (
                                            <Fragment>
                                                {getStepContent(activeStep)}
                                            </Fragment>
                                        )
                                    }
                                </Fragment>
                            </StepContent>
                        </Step>
                    ))
                }
            </Stepper>
        </Fragment>
    }

    const timeLifeTokenObj = filterArrayEqual(parameters, 'code', 'TIME_LIFE_TOKEN')
    const timeLifeToken = (timeLifeTokenObj.length > 0) ? Number(timeLifeTokenObj[0].value) : 180000

    return (
        <div>
            <LoadingScreen open={loading} />
            <Dashboard
                title=""
                body={renderBody()}
                multiple={false}
            />
            <StandardDialog
                fullScreen={false}
                open={dialog.state}
                title={dialog.title}
                handleClose={() => cleanDialog()} >
                {dialog.content}
            </StandardDialog>
            {/* <DialogOTP
                openDialogOTP={OTP.openOtp}
                onCloseDialogOTP={() => setOTP({ ...OTP, openOtp: false })}
                initialTime={Date.now()}
                loading={loading}
                showQR={false}
                OTPSubmit={handleOTPCompare}
                handleChangeInputOtp={handleChangeInputOtp}
            /> */}
            <DialogOTP
                openDialogOTP={openDialogOtp}
                onCloseDialogOTP={() => setOpenDialogOtp(false)}
                initialTime={Date.now()}
                loading={loading}
                showQR={false}
                OTPSubmit={handleOTPCompare}
                onKeyPress={handleChangeInputOtp}
                timeLifeToken={timeLifeToken}
                refreshToken={handleProcessGenerateOtp}

            />
            {/* <DialogOTP
                openDialogOTP={OTP.openOtp}
                onCloseDialogOTP={() => setOTP({ ...OTP, openOtp: false })}
                initialTime={Date.now()}
                loading={loading}
                showQR={false}
                OTPSubmit={handleOTPCompare}
                onKeyPress={handleChangeInputOtp}
                timeLifeToken={timeLifeToken}
                refreshToken={handleAcceptDialogConfirmationTransaction}

            /> */}
        </div>
    );
};

CreditRequestTestContainer.propTypes = {

};

// export default CreditRequestTestContainer;
export default connect(null, {
    createProcessMeterCode,
    getCreditDestiny,
    getCreditApplicationQualifier,
    getCreditInformation
})(CreditRequestTestContainer)